import request from './../utils/request'


export function index(params) {
  	return request({
  	  url: '/citizenships',
  	  method: 'get',
        params
  	})
  }
 
  export function inventory(params) {
    return request({
      url: '/citizenships/inventory',
      method: 'get',
      params
    })
  }

export function show(id) {
    return request({
      url: `/citizenships/${id}`,
      method: 'get'
    })
  }

  export function store(data) {
    return request({
      url: '/citizenships',
      method: 'post',
      data
    })
  }

  export function update(data) {
    return request({
      url: `/citizenships/${data.id}`,
      method: 'put',
      data
    })
  }

  export function destroy(id) {
    return request({
      url: `/citizenships/${id}`,
      method: 'delete',
    })
  }
